import type { ComponentProps } from 'react';

const JourneyIcon = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="1"
        y="15.7701"
        width="21.9418"
        height="0.954013"
        fill="#4E9594"
      />
      <path
        d="M5.29296 16.2471C5.29296 17.3009 4.43872 18.1551 3.38498 18.1551C2.33124 18.1551 1.477 17.3009 1.477 16.2471C1.477 15.1933 2.33124 14.3391 3.38498 14.3391C4.43872 14.3391 5.29296 15.1933 5.29296 16.2471Z"
        fill="#5CB0AB"
        stroke="#98E4D9"
        stroke-width="0.954002"
      />
      <path
        d="M12.9258 16.2471C12.9258 17.3009 12.0715 18.1551 11.0178 18.1551C9.96405 18.1551 9.10981 17.3009 9.10981 16.2471C9.10981 15.1933 9.96405 14.3391 11.0178 14.3391C12.0715 14.3391 12.9258 15.1933 12.9258 16.2471Z"
        fill="#5CB0AB"
        stroke="#98E4D9"
        stroke-width="0.954002"
      />
      <ellipse
        cx="21.5106"
        cy="16.2471"
        rx="5.24695"
        ry="5.24707"
        fill="#98E4D9"
      />
      <path
        d="M33.748 19.2027C33.748 19.2027 39.2837 23.0711 37.4506 25.1395L41.2827 30.0391C41.2827 30.0391 43.2515 30.1747 43.3179 30.0722C43.3842 29.9697 43.6194 21.7384 43.6194 21.7384L36.4164 15.3011L33.748 19.2027Z"
        fill="#FFBF9F"
      />
      <path
        d="M45.4734 27.7199L24.5488 18.5117L25.384 16.6091L46.3116 25.8174C46.4364 25.8723 46.5491 25.9513 46.6434 26.0499C46.7376 26.1484 46.8115 26.2646 46.8608 26.3917C46.91 26.5189 46.9338 26.6545 46.9306 26.7908C46.9274 26.9272 46.8974 27.0615 46.8422 27.1862C46.7312 27.4383 46.5247 27.636 46.2681 27.7361C46.0115 27.8361 45.7257 27.8303 45.4734 27.7199Z"
        fill="#E26257"
      />
      <path
        d="M42.5864 30.0731L31.7804 33.6099L27.4809 27.3414L26.9141 19.3362C26.9141 19.3362 29.0246 18.0035 30.4809 21.3714C31.9372 24.7393 32.6156 27.3746 35.9502 25.8941C36.3693 25.7102 37.0658 25.3816 37.8678 24.9896"
        fill="#FFBF9F"
      />
      <path
        d="M28.8125 17.3381C28.8125 17.3381 28.8457 19.5723 33.7482 19.2045L36.4828 15.5863L36.4165 15.318C36.4165 15.318 34.6497 14.715 31.713 15.5863C28.7763 16.4577 28.8125 17.3381 28.8125 17.3381Z"
        fill="#FFBF9F"
      />
      <path
        d="M31.5137 33.2758L32.2946 36.8668L46.6071 36.7945L43.384 29.1752L31.5137 33.2758Z"
        fill="#EA7A0A"
      />
      <path
        d="M34.3182 35.3217C34.7528 35.3217 35.1051 34.9694 35.1051 34.5348C35.1051 34.1001 34.7528 33.7478 34.3182 33.7478C33.8836 33.7478 33.5312 34.1001 33.5312 34.5348C33.5312 34.9694 33.8836 35.3217 34.3182 35.3217Z"
        fill="#FBAE17"
      />
      <path
        d="M41.613 23.3394L40.3828 26.0077L44.9446 27.9977C45.2921 28.1481 45.6841 28.159 46.0394 28.0282C46.3947 27.8974 46.6861 27.635 46.8531 27.2952C46.9396 27.1171 46.9892 26.9233 46.999 26.7256C47.0088 26.5278 46.9786 26.3301 46.9102 26.1443C46.8418 25.9585 46.7366 25.7884 46.6009 25.6442C46.4652 25.5001 46.3018 25.3848 46.1205 25.3052L41.613 23.3394Z"
        fill="#B43432"
      />
      <path
        d="M23.3217 17.4122L24.5518 18.5128L25.4021 16.6102L23.8282 16.357C23.7036 16.3358 23.5756 16.3534 23.4613 16.4073C23.347 16.4612 23.252 16.5489 23.189 16.6585C23.1205 16.7801 23.0963 16.9216 23.1205 17.0591C23.1446 17.1966 23.2158 17.3214 23.3217 17.4122Z"
        fill="#B43432"
      />
      <path
        d="M46.6394 36.0397H19.127V37.5472H46.6394V36.0397Z"
        fill="#E3E0DB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.3803 14.7623L20.588 19.0963L18.1934 16.7016L19.104 15.7909L20.5253 17.2122L23.411 13.9142L24.3803 14.7623Z"
        fill="#EBFEFA"
      />
    </svg>
  );
};

export default JourneyIcon;
